import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Card, Radio, Spin } from "antd";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { getAdjustedDate } from "./CommonFunctions";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../Utils/DateConverstion";
import { APIConstants } from "../../Common/APIConstants";

const WaterSankey = ({activeTab}) => {
  const chartRef = useRef(null);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [sankeyData, setSankeyData] = useState({ nodes: [], links: [] });
  const correctDate = new Date(getAdjustedDate());
  const[isLoading,setIsLoading]=useState(false)
  const defaultFromDate = dayjs()
    .subtract(1, "day")
    .hour(6)
    .minute(0)
    .second(0);
  const defaultToDate = dayjs().hour(6).minute(0).second(0);
  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [inputType,setInputType]=useState(0)
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // console.log(color);
  const colors = ["#59c3c9", "#696969", "#C8ff08", "#005E60"];
  const [selectedOption, setSelectedOption] = useState("1");

const handleRadioChange = (e) => {
  const selectedValue = e.target.value;
  setSelectedOption(selectedValue);
  // console.log(selectedValue)
  if(selectedValue==1){
    setInputType(0)
  }else{
    setInputType(1)
  }

  if (selectedValue == 1) {
    setFromDate(dayjs().subtract(1, "day").hour(6).minute(0).second(0));
    setToDate(dayjs().hour(6).minute(0).second(0));

  } else if (selectedValue == 2) {
    setFromDate(dayjs().startOf("month").hour(6).minute(0).second(0));
    setToDate(dayjs().hour(6).minute(0).second(0));
  }
};

function removeFirstAndAddConsumption(data) {
  if (!Array.isArray(data) || data.length < 2) {
    return data;
  }

  const [first, second, ...rest] = data;

  const updatedFirst = {
    ...first,
    // target:'',
    // source:'',
    consumption:  (first.consumption || 0),
  };

  return [updatedFirst,second, ...rest];
}

// useEffect(() => {
//   const nodes = [
//     { name: "WATER SOURCE", value: 136 },
//     { name: "RAW WATER INLET", value: 108 },

//     { name: "RO WATER INLET", value: 47 },
//     { name: "RAW WATER OUTLET", value: 61 },

//     { name: "Shift-I", value: 54 },
//     { name: "Shift-II", value: 39 },
//     { name: "Shift-III", value: 14 }, 

//     { name: "RO WATER OUT", value: 32 },
//     { name: "RO REJECT WATER", value: 14 },
//     { name: "TOILET", value: 18 },
//     { name: "SAND PLANT", value: 4 },
//     { name: "CANTEEN", value: 13 },
//     { name: "GARDENING", value: 24 },
//   ];

//   const links = [
//     // Level 1 → Level 2
//     { source: "WATER SOURCE", target: "RAW WATER INLET", value: 108 },
//     { source: "RAW WATER INLET", target: "RO WATER INLET", value: 47 },
//     { source: "RAW WATER INLET", target: "RAW WATER OUTLET", value: 61 },

//     // Level 2 → Level 3
//     { source: "RO WATER INLET", target: "Shift-I", value: 25 },
//     { source: "RO WATER INLET", target: "Shift-II", value: 15 },
//     { source: "RO WATER INLET", target: "Shift-III", value: 7 },

//     { source: "RAW WATER OUTLET", target: "Shift-I", value: 29 },
//     { source: "RAW WATER OUTLET", target: "Shift-II", value: 24 },
//     { source: "RAW WATER OUTLET", target: "Shift-III", value: 7 },

//     // Level 3 → Level 4
//     { source: "Shift-I", target: "RO WATER OUT", value: 32 },
//     { source: "Shift-I", target: "TOILET", value: 12 },
//     { source: "Shift-I", target: "CANTEEN", value: 10 },

//     { source: "Shift-II", target: "RO REJECT WATER", value: 14 },
//     { source: "Shift-II", target: "GARDENING", value: 24 },
//     { source: "Shift-II", target: "SAND PLANT", value: 1 },

//     { source: "Shift-III", target: "SAND PLANT", value: 3 },
//   ];

//   setSankeyData({ nodes, links });
// }, []);


  useEffect(() => {
  const colorList = ["#59c3c9", "#696969", "#C8ff08", "#005E60"];

const fetchData = async () => {
  setIsLoading(true);

  const inputData = {
    FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
    ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
  };

  const response = await makeRequest({
    type: APIConstants.GET,
    url: `${APIConstants.DASHBOARD_SANKEY_WATER}/${inputData.FromDate}/${inputData.ToDate}/${inputType}`,
  });

  const nodesSet = new Set();
  const links = [];
  const nodeValueMap = new Map();

  const targetColorMap = new Map();
  let colorIndex = 0;

  console.log(response)
  // Process each link data from response
  response?.forEach((item) => {
    const source = item.source || "Total";
    const target = item.target || "Total";
    const value = item.consumption ?? 0;

    // Track nodes
    nodesSet.add(source);
    nodesSet.add(target);

    // For now, assign values directly, but we will fix "Raw Water Inlet" later
    if (!nodeValueMap.has(source)) {
      nodeValueMap.set(source, value);
    }

    if (!nodeValueMap.has(target)) {
      nodeValueMap.set(target, value);
    }

    // Assign colors per target for styling links
    if (!targetColorMap.has(target)) {
      targetColorMap.set(target, colorList[colorIndex % colorList.length]);
      colorIndex++;
    }

    // Push link with value and color style
    links.push({
      source,
      target,
      value,
      lineStyle: {
        color: targetColorMap.get(target),
      },
    });
  });

  // --- SUM UP "RO WATER INLET" AND "RAW WATER OUTLET" INTO "Raw Water Inlet" ---

  const roWaterInletValue = nodeValueMap.get("RO WATER INLET") || 0;
  const rawWaterOutletValue = nodeValueMap.get("RAW WATER OUTLET") || 0;
  const combinedValue = roWaterInletValue + rawWaterOutletValue;

  // Add/update "Raw Water Inlet" node with combined value
  nodeValueMap.set("Raw Water Inlet", combinedValue);

  // Remove old nodes from nodesSet and add the new combined node
  // nodesSet.delete("RO WATER INLET");
  // nodesSet.delete("RAW WATER OUTLET");
  // nodesSet.add("Raw Water Inlet");

  // Update links:
  // Replace any source or target "RO WATER INLET" or "RAW WATER OUTLET" with "Raw Water Inlet"
  // const updatedLinks = links.map((link) => ({
  //   ...link,
  //   source:
  //     link.source === "RO WATER INLET" || link.source === "RAW WATER OUTLET"
  //       ? "Raw Water Inlet"
  //       : link.source,
  //   target:
  //     link.target === "RO WATER INLET" || link.target === "RAW WATER OUTLET"
  //       ? "Raw Water Inlet"
  //       : link.target,
  // }));

  // Build updated nodes array with correct values
  const nodes = Array.from(nodesSet).map((name) => ({
    name,
    value: nodeValueMap.get(name) ?? 0,
  }));

  // Set updated sankey data
  // console.log(updatedLinks)
  setSankeyData({ nodes, links: links });
   
  setIsLoading(false);
};


  fetchData();
}, [inputType]);

useEffect(() => {
  if (!chartRef.current) return;

  const chart = echarts.init(chartRef.current);
  const labelColor = isdarkMode ? "#fff" : "#000";

  // Build a map: parentName => sum of all its direct children's values
  const childrenSumMap = new Map();

  sankeyData.nodes.forEach((node) => {
    const children = sankeyData.links
      .filter((link) => link.source === node.name)
      .map((link) => link.target);

    const childrenSum = children.reduce((sum, childName) => {
      const childNode = sankeyData.nodes.find((n) => n.name === childName);
      return sum + (childNode?.value || 0);
    }, 0);

    childrenSumMap.set(node.name, childrenSum);
  });

  // Detect leaf nodes (no outgoing edges)
  const sourceNodes = new Set(sankeyData.links.map((l) => l.source));
  const leafNodes = sankeyData.nodes
    .filter((node) => !sourceNodes.has(node.name))
    .map((node) => node.name);

  const allValuesZero = sankeyData.links.every((l) => (l.value ?? 0) === 0);

  if (allValuesZero) {
    chart.setOption({
      graphic: {
        elements: [
          {
            type: "text",
            left: "center",
            top: "middle",
            style: {
              text: "No data available",
              fontSize: 20,
              fill: isdarkMode ? "#aaa" : "#555",
            },
          },
        ],
      },
    });
  } else {
    chart.setOption({
      tooltip: { trigger: "item", triggerOn: "mousemove" },
      toolbox: {
        show: true,
        right: 20,
        feature: {
          saveAsImage: {
            show: true,
            title: "Download Image",
            type: "png",
            name: "Sankey_Chart",
            backgroundColor: isdarkMode ? "#000" : "#fff",
            pixelRatio: 2,
          },
        },
      },
      animationDuration: 800,
      series: [
        {
          type: "sankey",
          data: sankeyData.nodes,
          links: sankeyData.links,
          layout: "none",
          emphasis: { focus: "adjacency" },
          lineStyle: { curveness: 0.5 },
          label: {
            color: labelColor,
            formatter: (params) => {
              const name = params.name;
              const value = params.value || 0;

              if (leafNodes.includes(name)) {
                // Find all parents of this leaf node
                const parents = sankeyData.links
                  .filter((l) => l.target === name)
                  .map((l) => l.source);

                if (parents.length === 0) {
                  // No parent? Just show value
                  return `${name} ${value}`;
                }

                // Determine denominator based on the child's name (your formula)
                let denominator = null;

                if (name === "RO WATER OUT" || name === "RO REJECT WATER") {
                  denominator = childrenSumMap.get("RO WATER INLET") || 0;
                } else if (
                  ["TOILET", "SAND PLANT", "CANTEEN", "GARDENING"].includes(name)
                ) {
                  denominator = childrenSumMap.get("RAW WATER OUTLET") || 0;
                } else {
                  // Fallback: if multiple parents, sum their children sums
                  denominator = parents.reduce((sum, p) => {
                    return sum + (childrenSumMap.get(p) || 0);
                  }, 0);
                }

                if (denominator > 0) {
                  const percent = ((value / denominator) * 100).toFixed(1);
                  return `${name} ${value} (${percent}%)`;
                }
              }

              // Default display
              return `${name} ${value}`;
            },
          },
        },
      ],
    });
  }

  const resizeObserver = new ResizeObserver(() => chart.resize());
  resizeObserver.observe(chartRef.current);

  return () => {
    resizeObserver.disconnect();
    chart.dispose();
  };
}, [sankeyData, isdarkMode]);



  console.log(sankeyData);

  return (
        <Card
      title={
        <div className={`${isdarkMode?'text-white':'text-black'}`}>
        {activeTab==="3"?" Nemak Aluminium – Energy Consumption Statistics":"Nemak Aluminium – Water Consumption Statistics"}
          {/* Energy Consumption Statistics */}
        </div>
      }
      hoverable
      className="shadow-md rounded-xl border max-h-[75vh]"
      style={{
        background: isdarkMode ? "#1f2937" : "#ffffff",
        color: isdarkMode ? "white" : "black",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "10px" }} >
        <Radio.Group  onChange={handleRadioChange} value={selectedOption}>
          <Radio className={`${isdarkMode?'text-white':'text-black'}`} value="1">Yesterday Consumption ({"m3"})</Radio>
          <Radio  className={`${isdarkMode?'text-white':'text-black'}`} value="2">MTD Consumption ({"m3"})</Radio>
        </Radio.Group>
      </div>
      
<div
  style={{
    position: "relative",
    width: "100%",
    height: "60vh",
    minHeight: "400px",
    maxHeight: "70vh"
  }}
>
  {isLoading && (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.6)",
        zIndex: 10
      }}
    >
      <Spin size="large" />
    </div>
  )}

  <div
    ref={chartRef}
    style={{
      width: "100%",
      height: "100%",
      overflow: "hidden"
    }}
  />
</div>
      {/* <div 
       ref={chartRef} 
       style={{
    width: "100%",
    height: "60vh",
    minHeight: "400px",
    maxHeight: "70vh",
    overflow: "hidden"
  }}></div> */}
    </Card>

  );
};


// const WaterSankey = ({activeTab}) => {
//   const chartRef = useRef(null);
//   const { makeRequest } = useStoreUpdaterWithAPI();
//   const [sankeyData, setSankeyData] = useState({ nodes: [], links: [] });
//   const correctDate = new Date(getAdjustedDate());
//   const[isLoading,setIsLoading]=useState(false)
//   const defaultFromDate = dayjs()
//     .subtract(1, "day")
//     .hour(6)
//     .minute(0)
//     .second(0);
//   const defaultToDate = dayjs().hour(6).minute(0).second(0);
//   const [toDate, setToDate] = useState(defaultToDate);
//   const [fromDate, setFromDate] = useState(defaultFromDate);
//   const [inputType,setInputType]=useState(0)
//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;
//   const color = useSelector((state) => state.ThemeChange);
//   // console.log(color);
//   const colors = ["#59c3c9", "#696969", "#C8ff08", "#005E60"];
//   const [selectedOption, setSelectedOption] = useState("1");

// const handleRadioChange = (e) => {
//   const selectedValue = e.target.value;
//   setSelectedOption(selectedValue);
//   // console.log(selectedValue)
//   if(selectedValue==1){
//     setInputType(0)
//   }else{
//     setInputType(1)
//   }

//   if (selectedValue == 1) {
//     setFromDate(dayjs().subtract(1, "day").hour(6).minute(0).second(0));
//     setToDate(dayjs().hour(6).minute(0).second(0));

//   } else if (selectedValue == 2) {
//     setFromDate(dayjs().startOf("month").hour(6).minute(0).second(0));
//     setToDate(dayjs().hour(6).minute(0).second(0));
//   }
// };

//   useEffect(() => {

//     const colorList = ["#59c3c9", "#696969", "#C8ff08", "#005E60"]; // Ordered colors

//     const fetchData = async () => {
//       setIsLoading(true)
//       const inputData = {
//         FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
//         ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
//       };
//       console.log(inputType)

//       const response = await makeRequest({
//         type: APIConstants.GET,
//         url: `${APIConstants.DASHBOARD_SANKEY_WATER}/${inputData.FromDate}/${inputData.ToDate}/${inputType}`});
//       console.log(response);

//       const nodesSet = new Set();
//       const links = [];
 
//       const targetColorMap = new Map();
//       let colorIndex = 0;

//       response?.forEach((item) => {
//         const source = item.source || "Total";
//         const target = item.target || "Total";
//         const value = item.consumption;

//         nodesSet.add(source);
//         nodesSet.add(target);

//         // Assign a color in order for each new target
//         if (!targetColorMap.has(target)) {
//           const color = colorList[colorIndex % colorList.length];
//           targetColorMap.set(target, color);
//           colorIndex++;
//         }

//         links.push({
//           source,
//           target,
//           value,
//           lineStyle: { color: targetColorMap.get(target) },
//         });
//       });

//       const nodes = Array.from(nodesSet).map((name) => ({ name }));
//       setSankeyData({ nodes, links });
//       console.log(nodes,links)
//       setIsLoading(false)
//     }; 

//     fetchData();
//   }, [inputType]);

// useEffect(() => {
//     if (!chartRef.current) return;

//     const chart = echarts.init(chartRef.current);

//     const labelColor = isdarkMode ? "#fff" : "#000";

//     // Detect first level and root total
//     const rootName = sankeyData.nodes?.[0]?.name;
//     const rootTotal = sankeyData.links
//       .filter((l) => l.source === rootName)
//       .reduce((sum, l) => sum + (l.value || 0), 0);

//     // Detect leaf nodes (no outgoing edges)
//     const sourceNodes = new Set(sankeyData.links.map((l) => l.source));
//     const leafNodes = sankeyData.nodes
//       .filter((node) => !sourceNodes.has(node.name))
//       .map((node) => node.name);

//     const allValuesZero = sankeyData.links.every(
//       (l) => (l.value ?? 0) === 0
//     );

//  const parentTotals = {};

// sankeyData.links.forEach(({ source, value }) => {
//   if (!parentTotals[source]) parentTotals[source] = 0;
//   parentTotals[source] += value || 0;
// });



//     if (allValuesZero) {
//       chart.setOption({
//         graphic: {
//           elements: [
//             {
//               type: "text",
//               left: "center",
//               top: "middle",
//               style: {
//                 text: "No data available",
//                 fontSize: 20,
//                 fill: isdarkMode ? "#aaa" : "#555",
//               },
//             },
//           ],
//         },
//       });
//     } else {
//      chart.setOption({
//   tooltip: { trigger: "item", triggerOn: "mousemove" },

//   toolbox: {
//     show: true,
//     right: 20,
//     feature: {
//       saveAsImage: {
//         show: true,
//         title: "Download Image",
//         type: "png",          // png | jpeg | svg
//         name: "Sankey_Chart", // file name
//         backgroundColor: isdarkMode ? "#000" : "#fff",
//         pixelRatio: 2         // higher = better quality
//       }
//     }
//   },

//   animationDuration: 800,
//   series: [
//     {
//       type: "sankey",
//       data: sankeyData.nodes,
//       links: sankeyData.links,
//       layout: "none",
//       emphasis: { focus: "adjacency" },
//       lineStyle: { curveness: 0.5 },
//  label: {
//   color: labelColor,
//   formatter: (params) => {
//     const name = params.name;
//     const value = params.value || 0;

//     // Only calculate percentage for LAST stage (leaf nodes)
//     if (!leafNodes.includes(name)) {
//       return `${name} ${value}`;
//     }

//     // Find parent of this leaf node
//     const parentLink = sankeyData.links.find(
//       (l) => l.target === name
//     );

//     if (!parentLink) {
//       return `${name} ${value}`;
//     }

//     const parentName = parentLink.source;
//     const parentTotal = parentTotals[parentName] || 0;

//     if (!parentTotal) {
//       return `${name} ${value}`;
//     }

//     const percent = ((value / parentTotal) * 100).toFixed(1);

//     return `${name} ${value} (${percent}%)`;
//   },
// },

//     },
//   ],
// });

//     }

//     const resizeObserver = new ResizeObserver(() => chart.resize());
//     resizeObserver.observe(chartRef.current);

//     return () => {
//       resizeObserver.disconnect();
//       chart.dispose();
//     };
//   }, [sankeyData, isdarkMode]);


//   console.log(sankeyData);

//   return (
//         <Card
//       title={
//         <div className={`${isdarkMode?'text-white':'text-black'}`}>
//         {activeTab==="3"?" Nemak Aluminium – Energy Consumption Statistics":"Nemak Aluminium – Gas Consumption Statistics"}
//           {/* Energy Consumption Statistics */}
//         </div>
//       }
//       hoverable
//       className="shadow-md rounded-xl border max-h-[75vh]"
//       style={{
//         background: isdarkMode ? "#1f2937" : "#ffffff",
//         color: isdarkMode ? "white" : "black",
//       }}
//     >
//       <div style={{ textAlign: "center", marginBottom: "10px" }} >
//         <Radio.Group  onChange={handleRadioChange} value={selectedOption}>
//           <Radio className={`${isdarkMode?'text-white':'text-black'}`} value="1">Yesterday Consumption ({activeTab==="3"?"kWh":"Kg"})</Radio>
//           <Radio  className={`${isdarkMode?'text-white':'text-black'}`} value="2">MTD Consumption ({activeTab==="3"?"kWh":"Kg"})</Radio>
//         </Radio.Group>
//       </div>
      
// <div
//   style={{
//     position: "relative",
//     width: "100%",
//     height: "60vh",
//     minHeight: "400px",
//     maxHeight: "70vh"
//   }}
// >
//   {isLoading && (
//     <div
//       style={{
//         position: "absolute",
//         inset: 0,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "rgba(255,255,255,0.6)",
//         zIndex: 10
//       }}
//     >
//       <Spin size="large" />
//     </div>
//   )}

//   <div
//     ref={chartRef}
//     style={{
//       width: "100%",
//       height: "100%",
//       overflow: "hidden"
//     }}
//   />
// </div>
//       {/* <div 
//        ref={chartRef} 
//        style={{
//     width: "100%",
//     height: "60vh",
//     minHeight: "400px",
//     maxHeight: "70vh",
//     overflow: "hidden"
//   }}></div> */}
//     </Card>

//   );
// };


export default WaterSankey;
